import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getConfigByEnv } from "./Helpers/getConfigByEnv";


const firebaseApp = initializeApp(getConfigByEnv(process.env.REACT_APP_ENV).FIREBASE_CONFIG);
const db = getFirestore(firebaseApp);

export { firebaseApp, db };